<template>
  <div class="mycourse">
    <Row class="top-title" type="flex" justify="space-between" align="bottom">
      <i-col span="8" class="title-left">
        <span>我的课程</span>
        <router-link to="/mymenu">我的首页</router-link>
      </i-col>
    </Row>
    <Row>
      <i-col span="17">
        <div class="course-tip">
          <p class="course-name">{{courseInfo.courseName}}</p>
          <Row type="flex" align="middle" justify="space-between">
            <div class="map-wrapper">
              <div
                class="map-img"
                :style="{background: 'url(' + courseInfo.courseMapFileUrl + ') no-repeat', backgroundSize:'auto', height: '1000px'}"
              >
                <div
                  v-for="(unit, index) in courseUnitResult.records"
                  :key="unit.id"
                  :class="['unit', unit.isOpen?'opened':'gray']"
                  :style="{left: unit.mapX-25+'px', top: unit.mapY-25+'px'}"
                  @click="viewUnit(unit)"
                >
                  <i class="flag" :class="[isPoint(index,unit)?'point':'']">
                    <img
                      class="arrow"
                      v-if="isPoint(index,unit)"
                      src="@/assets/mycourse/arrow.svg"
                      alt
                    />
                    <img :src="'/static/img/map-ico/'+(index+1)+'.png'" alt />
                  </i>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </i-col>
      <i-col span="7">
        <div>
          <p style="font-size:18px;color:white;">
            您还有
            <span style="color:#F59A23;">{{unFinishedWork.length * 10}}积fun</span>可获得
          </p>
          <br />
          <Carousel autoplay loop :autoplay-speed="3000" arrow="never" dots="none">
            <Carousel-item v-for="(item,index) in integralLog" :key="index">
              <p style="color:white">
                {{item.realname}} {{item.rule_name}}获得了
                <span
                  style="color:#F59A23;"
                >{{item.integral}} 积fun</span>
              </p>
            </Carousel-item>
          </Carousel>
          <br />
          <div class="course-work" style>
            <Button-group>
               <i-button @click="showFishisedWork=false" :disabled="showFishisedWork==false">未完成</i-button>
               <i-button @click="showFishisedWork=true" :disabled="showFishisedWork==true">已完成</i-button>
            </Button-group>
            <div v-if="showFishisedWork==false">
              <Row v-for="(item, index) in unFinishedWork" :key="index" style>
              <div @click="viewWork(item)" :class="item.isOpen?'':'gray'">
                <i-col span="8">
                  <img width="112" height="70" :src="item.unitCoverFileUrl" alt />
                </i-col>
                <i-col span="12" style="margin-left: 20px;text-align: left;color:white">
                  <h4>{{item.unitName}} -- 课后作业</h4>
                  <p>{{item.unitDesc}}</p>
                </i-col>
              </div>
            </Row>
            </div>
             <div v-if="showFishisedWork==true">
            <Row v-for="(item, index) in finishedWork" :key="index" style>
              <div @click="viewWork(item)" :class="item.isOpen?'':'gray'">
                <i-col span="8">
                  <img width="112" height="70" :src="item.unitCoverFileUrl" alt />
                </i-col>
                <i-col span="12" style="margin-left: 20px;text-align: left;color:white">
                  <h4>{{item.unitName}} -- 课后作业</h4>
                  <p>{{item.unitDesc}}</p>
                </i-col>
              </div>
            </Row>
             </div>
          </div>
        </div>
        <br />
        <div class="mine-skill" style>
          <div>
            <h3>我的收获</h3>
            <br>
            <hr />
            <br>
            <Row>
              <i-col span="4">证书：</i-col>
              <i-col span="20">人工智能 等级1</i-col>
            </Row>
            <br>
            <Row>
              <i-col span="4">积fun：</i-col>
              <i-col span="20">60fun</i-col>
            </Row>
            <br>
            <Row v-if="courseInfo.courseSkill">
              <i-col span="4">技能：</i-col>
              <i-col span="20">
                <div v-for="(item, index) in courseInfo.courseSkill.split('\n')" :key="index">
                  <span style="width:80px;display: inline-block;">{{item.split(':')[0]}}</span>
                  <Progress :percent="item.split(':')[1]" style="width: 235px;">
                    <span>{{item.split(':')[1]}}</span>
                  </Progress>
                </div>
              </i-col>
            </Row>
          </div>
        </div>
      </i-col>
    </Row>
    <div class="enter-unit-wrap" v-if="showEnterModal" @click="showEnterModal=false">
      <div class="enter-unit">
        <svg-icon class="badge" icon-class="badge" />
        <h1>你已完成{{currentUnit.mineWorkId?'100':'0'}}%课程进度</h1>
        <div>
          <div @mouseover="isShowEnter = true">
            <svg-icon class="robot" icon-class="robot" />
          </div>
          <div
            class="percent"
            v-show="isShowEnter === true"
            @mouseleave="isShowEnter = false"
            @click="toUnit"
          >
            <div v-if="currentUnit.isOpen">
              <p>继续</p>
              <p>挑战</p>
            </div>
            <div v-else>未开课</div>
          </div>
        </div>
        <h1 v-if="currentUnit.isOpen">已开课</h1>
        <h1 v-else>{{currentUnit.openTime}}开课</h1>
      </div>
    </div>
  </div>
</template>
<script>
import { getCourseUnit, getCourseInfo } from "@/api/course";
import { removeToken, removeUserInfo } from "@/utils/auth";
import request from "@/api/axios";
export default {
  data() {
    return {
      type: "0",
      courseId: "",
      departId: "",
      courseInfo: {},
      courseUnitResult: {},
      integralLog: [],
      showFishisedWork: false,
      finishedWork: [],
      unFinishedWork: [],
      isShowEnter: false,
      showEnterModal: false,
      currentUnit: {},
    };
  },
  created() {
    // this.getMineCourse(1, 99);
    // this.getMineReview();
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourseUnit();
    this.getCourseInfo();
    // this.getCourseWorkInfo();
    request({
      url: "/api/org.jeecg.modules.teaching/sysIntegralRule/getIntegralLog",
      method: "get",
    }).then((res) => {
      this.integralLog = res.result;
    });
  },
  methods: {
    getCourseInfo() {
      getCourseInfo(this.courseId).then((res) => {
        this.courseInfo = res.result.records[0];
      });
    },
    getCourseUnit() {
      getCourseUnit(this.departId, this.courseId, 1, 99).then((res) => {
        if (res.success) {
          this.courseUnitResult = res.result;
          this.unFinishedWork = res.result.records.filter((x) => {
            return x.mineWorkId == null;
          });
          this.finishedWork = res.result.records.filter((x)=>{
            return x.mineWorkId != null;
          })
        }
      });
    },
    // getCourseWorkInfo() {
    //   getCourseWorkInfo(this.courseId).then((res) => {
    //     this.unFinishedWork = res.result.filter((x) => {
    //       return x.mineWorkId == null;
    //     });
    //     console.log(this.unFinishedWork);
    //   });
    // },
    viewUnit(unit) {
      this.showEnterModal = true;
      this.currentUnit = unit;
    },
    toUnit() {
      let unit = this.currentUnit;
      if (unit.openTime == null || unit.serverTime < unit.openTime) {
        return;
      }
      this.$router.push({
        path: `/attendclass?unitId=${unit.id}&courseId=${this.courseId}&departId=${this.departId}`,
      });
    },
    viewWork(work) {
      if (!work.isOpen) {
        this.$Message.info("未开课不可提交作业");
        return;
      }
      var submit = work.mineWorkId==null
      window.open(
        "/static/scratch3/index.html?scene=course&unitId=" +
          work.id +
          "&mediaId=" +
          work.workMediaId +
          "&submit=" + submit
      );
    },
    isPoint(index, unit) {
      if (unit.isOpen) {
        let list = this.courseUnitResult.records;
        let maxIndex = 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].isOpen) {
            maxIndex = i;
          }
        }
        if (maxIndex == index) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}

.point {
  animation: mymove 5s infinite;
  -webkit-animation: mymove 5s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 5s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
  .arrow {
    transform: rotate(-90deg);
    position: absolute;
    top: -101px;
    left: -11px;
    width: 120px;
  }
}

@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.3); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.3);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.3); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.3);
  }
}

.enter-unit-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(47, 79, 79, 0.6);
  .enter-unit {
    position: absolute;
    width: 520px;
    height: 470px;
    background-color: white;
    border-radius: 20px;
    left: 50%;
    top: 50%;
    padding-top: 84px;
    margin: -260px 0 0 -256px;
    .badge {
      position: absolute;
      width: 400px;
      height: 400px;
      left: 53px;
      top: -203px;
    }
    .robot {
      width: 200px;
      height: 200px;
    }
    .percent {
      background: rgba(0, 0, 0, 0.4);
      position: absolute;
      width: 200px;
      height: 200px;
      border: 15px solid #fef5a2;
      border-radius: 50%;
      top: 125px;
      left: 158px;
      color: white;
      font-size: 30px;
      padding-top: 35px;
      cursor: pointer;
    }
  }
}

.course-work {
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.18);
  width: 370px;
  height: 450px;
  padding: 20px;
  overflow: hidden;
  &:hover {
    overflow-y: scroll;
  }

  .ivu-row {
    margin-top: 5px;
    background: rgba(116, 70, 70, 0.1);
    &:hover {
      background: rgb(44, 191, 224);
    }
    cursor: pointer;
  }
}
.mine-skill {
  border-radius: 10px;
  background: #bf506a;
  width: 370px;
  height: 300px;
  color: white;
  text-align: left;
  padding: 10px;
}
.map-wrapper {
  width: 100%;
  .map-img {
    position: relative;
  }
}
.unit {
  width: 50px;
  height: 0;
  position: absolute;
  display: block;
  cursor: pointer;
  .flag {
    display: block;
    width: 64px;
    height: 64px;
  }
  // .unit-title {
  //   background-color: #52c41ab3;
  //   display: block;
  //   width: 64px;
  //   padding: 0.4em 0.6em 0.3em;
  //   font-size: 75%;
  //   font-weight: 700;
  //   line-height: 1;
  //   color: #fff;
  //   text-align: center;
  //   white-space: nowrap;
  //   vertical-align: baseline;
  //   border-radius: 0.25em;
  // }
}

.mycourse {
  width: 1280px;
  margin: 0 auto;
  .top-title {
    width: 1360px;
    margin: 40px auto 80px;
    .title-left {
      color: #fff;
      span {
        font-weight: 700;
        margin-right: 50px;
        font-size: 30px;
      }
      a {
        font-weight: 700;
        font-size: 20px;
        background: rgb(57, 165, 239);
        display: inline-block;
        border-radius: 30px;
        line-height: 30px;
        padding: 5px 36px;
      }
    }
    .title-right {
      font-size: 20px;
      color: #192648;
      border-radius: 30px;
      background: #fff;
      line-height: 40px;
      padding: 0px 36px;
      height: 40px;
      cursor: pointer;
      &:hover {
        background: #f5c54a;
        color: #fff;
      }
    }
  }
  video {
    width: 961px;
    height: 532px;
    background: #fff;
    margin: 0;
    padding: 0;
  }
  .course-tip {
    text-align: left;
    margin-top: 50px;
    margin-bottom: 20px;
    width: 1083px;
    p {
      &.course-name {
        letter-spacing: 2px;
        color: #fff;
        text-indent: 70px;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 50px;
      }
      &.tip {
        letter-spacing: 2px;
        color: #fff;
        text-indent: 80px;
        font-size: 16px;
      }
    }
    .check-btn {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      span {
        display: inline-block;
        border: 1px solid #fff;
        border-radius: 42px;
        padding: 0 20px;
        height: 42px;
        line-height: 42px;
        cursor: pointer;
        &:first-child {
          margin-right: 50px;
        }
      }
    }
  }
  .right-content {
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    width: 266px;

    p {
      color: #2d2d2d;
      font-weight: 700;
      font-size: 25px;
      padding-top: 26px;
      padding-bottom: 42px;
      text-align: center;
      border-bottom: 1px solid #e9e9e9;
    }
    ul {
      height: 300px;
      margin-top: 20px;
      li {
        text-align: left;
        line-height: 51px;
        font-size: 20px;
        color: #2d2d2d;
        padding-left: 35px;
        svg {
          width: 22px;
          height: 20px;
          margin-right: 20px;
        }
      }
    }
    .submit {
      text-align: center;
      span {
        width: 192px;
        height: 44px;
        background-color: rgba(245, 154, 35, 1);
        border-radius: 44px;
        display: inline-block;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 44px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/myunit.vue